import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import SignReceiptStatusBadge from '#/modules/crmMgmt/aftersales/signReceipt/components/SignReceiptStatusBadge';
import { mapSignReceiptMeta } from '#/modules/crmMgmt/aftersales/signReceipt/helper/formSerialize';

function displayOrDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

function HistoryField({ label, value }) {
  return (
    <div>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="mt-0.5 text-sm font-medium wrap-anywhere text-gray-900">{value}</p>
    </div>
  );
}

HistoryField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
};

const SignReceiptMainInfoCard = ({
  detail,
  embedded = false,
  actions = null,
  containerClassName = '',
}) => {
  const meta = mapSignReceiptMeta(detail);
  const surfacePaddingClassName = 'p-5';

  const content = (
    <>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className="text-2xl font-bold text-gray-900">{meta.code}</h1>
            {meta.status ? <SignReceiptStatusBadge status={meta.status} /> : null}
          </div>
        </div>
        {actions ? (
          <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
            {actions}
          </div>
        ) : null}
      </div>
      <div
        className={cn(
          'mt-4 grid grid-cols-1 gap-x-4 gap-y-3 border-t border-slate-200 pt-4',
          'sm:grid-cols-2 md:grid-cols-4',
        )}
      >
        <HistoryField label="建立" value={meta.createDate} />
        <HistoryField label="修改" value={meta.reviseDate} />
        <HistoryField label="成立" value={meta.establishedAt} />
        <HistoryField label="完成" value={meta.completedAt} />
        <HistoryField label="取消" value={meta.cancelledAt} />
        <HistoryField label="預計送交日" value={meta.signReceiptDate} />
        <HistoryField label="客戶" value={displayOrDash(meta.customerName)} />
        <HistoryField label="聯絡人" value={displayOrDash(meta.contactName)} />
        <HistoryField label="電話" value={displayOrDash(meta.phone)} />
        <HistoryField label="傳真" value={displayOrDash(meta.fax)} />
        <HistoryField label="統編" value={displayOrDash(meta.taxId)} />
        <HistoryField label="品項數" value={meta.lineCount} />
        <div className="sm:col-span-2 md:col-span-2">
          <p className="text-xs text-gray-500">地址</p>
          <p className="mt-0.5 text-sm font-medium wrap-break-word text-gray-900">
            {displayOrDash(meta.address)}
          </p>
        </div>
        <div className="sm:col-span-2 md:col-span-2">
          <p className="text-xs text-gray-500">備註</p>
          <p className="mt-0.5 text-sm font-medium wrap-break-word text-gray-900">
            {displayOrDash(meta.remark)}
          </p>
        </div>
      </div>
    </>
  );

  if (embedded) {
    return (
      <div className={cn('border-b border-slate-200', surfacePaddingClassName)}>
        {content}
      </div>
    );
  }

  return (
    <div className={cn('receipt-card-elevate', containerClassName)}>
      <div className={cn('receipt-card-surface', surfacePaddingClassName)}>
        {content}
      </div>
    </div>
  );
};

SignReceiptMainInfoCard.propTypes = {
  detail: PropTypes.object.isRequired,
  embedded: PropTypes.bool,
  actions: PropTypes.node,
  containerClassName: PropTypes.string,
};

export default SignReceiptMainInfoCard;
